import React from "react";
import {AuthFramePageFooterLink, AuthFramePageFooterLinks, NavAuthFramePageFooter} from "peggirkit";
import ThemeToggle from "@widgets/auth/ThemeToggle";
import {FormattedMessage} from "react-intl";
import router from "@/routing/Router";

const AuthenticationPageFooter = () => {
    return (
        <NavAuthFramePageFooter
            links={
                <AuthFramePageFooterLinks>
                    <ThemeToggle/>
                    <AuthFramePageFooterLink
                        action={{
                            as: "a",
                            actionProps: {href: router.employeeEnvironment.relativePath}
                        }}
                    >
                        <FormattedMessage id={"employee"}/>
                    </AuthFramePageFooterLink>
                    <AuthFramePageFooterLink
                        action={{
                            as: "a",
                            actionProps: {href: router.adminHome.relativePath}
                        }}
                    >
                        <FormattedMessage id={"adminEnv"}/>
                    </AuthFramePageFooterLink>
                    <AuthFramePageFooterLink
                        action={{
                            as: "a",
                            actionProps: {href: "https://eataliano.docs.peggir.com/"}
                        }}
                    >
                        <FormattedMessage id={"documentation"}/>
                    </AuthFramePageFooterLink>
                    <AuthFramePageFooterLink
                        action={{
                            as: "a",
                            actionProps: {href: "https://eataliano.nl/"}
                        }}
                    >
                        Eataliano.nl
                    </AuthFramePageFooterLink>
                </AuthFramePageFooterLinks>
            }
        >
            <FormattedMessage id={"copyrightStatement"}/>
        </NavAuthFramePageFooter>
    );
};

export default AuthenticationPageFooter;